import React, { FunctionComponent, CSSProperties } from 'react';
import styles from './styles.module.scss';
import { dashboardColors } from '../../common/helpers/colorHelper';
import { FormattedMessage } from 'react-intl';
import { defaultLabels } from './utils';
import { DashboardColor } from '../../common/enums/DashboardColor';

interface ICheckboxFilterItemProps {
  id?: string;
  name?: string;
  count: number;
  color: DashboardColor;
  intlId?: string;
  defaultText?: string;
}

const CheckboxFilterItem: FunctionComponent<ICheckboxFilterItemProps> = ({
  id,
  name,
  count,
  color,
  defaultText,
  intlId
}) => (
  <div className="d-flex align-items-center">
    <div className={`t-14 ${styles.lable}`}>
      <span>
        <FormattedMessage id={intlId || name} defaultMessage={defaultText || (id ? defaultLabels[id] : '')} />
      </span>
    </div>
    <div
      className={`d-flex justify-content-center align-items-center ${styles.itemCircle}`}
      style={{ '--color': dashboardColors[color].color,
        '--background-color': dashboardColors[color].backgroundColor } as CSSProperties}
    >
      <span className={`${styles.itemCount} t-14`}>{count}</span>
    </div>
  </div>
);

export default CheckboxFilterItem;
